<template>
  <div id="completaordine">
    <ShopSlider></ShopSlider>
    <div v-if="step === 0">
      <div class="row" style="margin-right: 0px">
        <div class="col-lg-12 directory">
          <router-link :to="{name: 'homepage'}">Home</router-link>
          /
          <router-link :to="{name: 'shop'}">Shop</router-link>
          /
          <router-link :to="{name: 'carrello'}">Carrello</router-link>
        </div>
        <div class="col-lg-5">
          <div class="col-lg-12 categoria" id="riepilogo">{{$t("summary")}}</div>
          <div class="col-lg-12 testoRiepilogo">
            <div class="righeRiepilogo" v-for="(vino, index) in cart">
              <riepilogo-carrello :vino="vino" :qntyProd="qntyProd[index]" v-if="qntyProd !== undefined"></riepilogo-carrello>
            </div>
          </div>
          <div class="somma" style="padding: 30px; color: #008000">
            <div class="sumRiepilogo">
              <div style="float: left; text-align: left">Prodotti:</div>
              <div style="text-align: right" v-price v-if="totale !== 0">{{totale}}</div>
            </div>
            <div class="sumRiepilogo" style="">
              <div style="float: left; text-align: left">Spedizione:</div>
              <div style="text-align: right">{{priceShip.toFixed(2)}} &euro;</div>
            </div>
            <hr style="border-top: 1px solid black"/>
            <div class="sumRiepilogo" id="sum" style="font-weight: bold;">
              <div style="float: left; text-align: left">Totale:</div>
              <div style="text-align: right" v-if="totale !== 0">{{(totale + priceShip).toFixed(2)}} &euro;</div>
            </div>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="col-lg-12 categoria" id="form">{{$t("form")}}</div>
          <div class="col-lg-12 form">
            <el-form ref="form" :model="form" :rules="rules" label-width="140px">
              <div
                class="horeca">Sei un ristorante? Contattaci per il canale Horeca. Clicca <a
                href="mailto:info@tenutaballerio.com?subject=Canale%20Horeca&body=Scrivici%20per%20prendere%20accordi%20per%20il%20canale%20Horeca">qui</a>
              </div>
              <el-form-item label="Indirizzo Mail:" prop="email" type="email">
                <el-input name="email" v-model="form.email" maxlength="120"
                          @blur="onSubmit('form')"></el-input>
                <br>
              </el-form-item>
              <el-form-item label="Nome:" prop="name" id="nome">
                <el-input type="text" v-model="form.name" @blur="onSubmit('form')" maxlength="120"
                          @change="checkSpecialChar(form.name, 'name')"></el-input>
              </el-form-item>
              <el-form-item label="Cognome:" prop="surname" id="cognome">
                <el-input type="text" v-model="form.surname" @blur="onSubmit('form')" maxlength="120"
                          @change="checkSpecialChar(form.surname, 'surname')"></el-input>
              </el-form-item>
              <el-form-item label="Ragione Sociale:" prop="ragsoc" id="ragsoc">
                <el-input v-model="form.ragsoc" @blur="onSubmit('form')" name="ragsoc" maxlength="120"
                          @change="checkSpecialChar(form.ragsoc, 'ragsoc')"></el-input>
              </el-form-item>
              <el-form-item label="Cellulare:" prop="tel">
                <el-input type="number" v-model="form.tel" @blur="onSubmit('form')" maxlength="120"></el-input>
              </el-form-item>
              <el-form-item label="Data di Nascita:" prop="birthday">
                <el-date-picker format="dd/MM/yyyy" :picker-options="pickerOptions1" type="date"
                                placeholder="Scegli la data" v-model="form.birthday" @blur="onSubmit('form')"
                                default-value="1990-01-01"></el-date-picker>
              </el-form-item>
              <div>
                <div
                  style="padding-bottom: 20px; width:30%; text-align:right; padding-top: 10px; font-weight: bold; font-size: 16px;"
                  class=".el-form-item__label">Residenza
                </div>
                <el-form-item label="Indirizzo:" prop="indResidenza">
                  <el-input v-model="form.indResidenza" @blur="onSubmit('form')" maxlength="120"
                            @change="checkSpecialChar(form.indResidenza, 'indResidenza')"></el-input>
                </el-form-item>
                <el-form-item label="Città:" prop="cityResidenza">
                  <el-input type="text" v-model="form.cityResidenza" @blur="onSubmit('form')" maxlength="120"
                            @change="checkSpecialChar(form.cityResidenza, 'cityResidenza')"></el-input>
                </el-form-item>
                <el-form-item label="CAP:" prop="capResidenza">
                  <el-input type="number" v-model="form.capResidenza" @blur="onSubmit('form')" max="2147483647"></el-input>
                </el-form-item>
                <el-form-item label="Provincia:" prop="provResidenza">
                  <el-input type="text" v-model="form.provResidenza" @blur="onSubmit('form')" maxlength="120"
                            @change="checkSpecialChar(form.provResidenza, 'provResidenza')"></el-input>
                </el-form-item>
                <el-form-item label="Nazione:" prop="nationResidenza">
                  <el-select v-model="form.nationResidenza" placeholder="Select" @change="onSubmit('form')">
                    <el-option disabled value="">Please select one</el-option>
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-checkbox name="type" class="notinlista" @change="writeMail(mailto)">Il mio stato non è in lista
                  </el-checkbox>
                </el-form-item>
                <el-form-item label="codice fiscale :" prop="fiscCode" v-if="form.nationResidenza === 'Italia'">
                  <el-input v-model="form.fiscCode" @blur="onSubmit('form')" name="codFisc"></el-input>
                </el-form-item>
              </div>
              <div style="padding-bottom: 30px">L'indirizzo di fatturazione è diverso da quello di residenza
                <input type="checkbox" id="checkbox" @click="setVisible">
              </div>
              <div v-if="fattura">
                <div
                  style="padding-bottom: 20px; width:30%; text-align:right; padding-top: 10px; font-weight: bold; font-size: 16px;"
                  class=".el-form-item__label">Fatturazione
                </div>
                <el-form-item label="Indirizzo:" prop="indFattura">
                  <el-input v-model="form.indFattura" @blur="onSubmit()" maxlength="120"
                            @change="checkSpecialChar(form.indFattura, 'indFattura')"></el-input>
                </el-form-item>
                <el-form-item label="Città:" prop="cityFattura">
                  <el-input type="text" v-model="form.cityFattura" @blur="onSubmit()" maxlength="120"
                            @change="checkSpecialChar(form.cityFattura, 'cityFattura')"></el-input>
                </el-form-item>
                <el-form-item label="CAP:" prop="capFattura">
                  <el-input type="number" v-model="form.capFattura" @blur="onSubmit()" max="2147483647"></el-input>
                </el-form-item>
                <el-form-item label="Provincia:" prop="provFattura">
                  <el-input type="text" v-model="form.provFattura" @blur="onSubmit()" maxlength="120"
                            @change="checkSpecialChar(form.provFattura, 'provFattura')"></el-input>
                </el-form-item>
                <el-form-item label="Nazione:" prop="nationFattura">
                  <el-select v-model="form.nationFattura" placeholder="Select" @change="onSubmit()">
                    <el-option disabled value="">Please select one</el-option>
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-checkbox name="type"
                               style="width: 41%;" @change="writeMail(mailto)">Il mio stato non è in lista
                  </el-checkbox>
                </el-form-item>
              </div>
              <el-form-item label="Partita iva :" prop="iva">
                <el-input v-model="form.iva" @blur="onSubmit('form')" maxlength="250"
                          @change="checkSpecialChar(form.iva, 'iva')"></el-input>
              </el-form-item>
              <!--<el-form-item label="Metodo di Pagamento :" prop="metodoPagamento">-->
                <!--<el-radio label="paypal" v-model="form.metodoPagamento" @change="onSubmit('form')">PayPal</el-radio>-->
                <!--<el-radio label="carta" v-model="form.metodoPagamento" @change="onSubmit('form')">Carta di Credito-->
                <!--</el-radio>-->
              <!--</el-form-item>-->
              <el-form-item label="Privacy:" prop="privacy">
                <el-button type="text" @click="dialogPrivacy = true"
                           style="width: 84%; text-align: left; padding-left: 2%;">
                  <el-checkbox v-model="form.privacy" label="Ho letto e accetto l'informativa sulla Privacy"
                               name="privacy" @change="onSubmit('form')"></el-checkbox>
                </el-button>
              </el-form-item>
              <el-form-item label="Marketing:" prop="marketing">
                <el-checkbox v-model="form.marketing"
                             label="Autorizzo il trattamento dei dati per lo svolgimento di attività promozionali, commerciali, newsletter, attraverso mailing list, compimento di attività statistiche, rilevazione del grado di soddisfazione, con strumenti automatizzati (ad esempio via e-mail, sms, mms) e con strumenti non automatizzati (telefono con operatore o posta cartacea)"
                             name="marketing" @change="onSubmit('form')">
                </el-checkbox>
              </el-form-item>
              <el-form-item label="Condizioni di vendita:" prop="condizionivendita">
                <el-button type="text" @click="dialogCondVendita = true"
                           style="width: 84%; text-align: left; padding-left: 2%;">
                  <el-checkbox v-model="form.condizionivendita" label="Ho letto e accetto le condizioni di vendita"
                               name="condizionivendita" @change="onSubmit('form')"></el-checkbox>
                </el-button>
              </el-form-item>
              <div class="horeca">Per completare il pagamento tramite carta di credito o paypal clicca qui</div>
              <paypal class="informazioni" :email="form.email" :nation="form.nationResidenza" :pay="pay"
                      :key="pay" @enablePay="enablePay" @successPay="successPay"></paypal>
            </el-form>
          </div>
        </div>
        <div class="row"
             style="width: -webkit-fill-available; margin-left: 0px; margin-right: 0px; margin-bottom: 50px">
          <b-btn class="indietro" :to="{name: 'carrello'}">Indietro
          </b-btn>
        </div>
      </div>
    </div>
    <div v-if="step===1">
      <div class="row" v-bind:style="{height: pageHeight/2.6 + 'px'}" style="margin-right: 0px; margin-left: 0px">
        <div style="text-align: center; width: 100%; margin: auto; color: white;">
          <strong>Pagamento effettuato con successo</strong><br>
          Grazie per il vostro ordine, presto vi arriverà un'email di conferma<br>
          <router-link :to="{name: 'homepage'}">Torna alla Homepage</router-link>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogPrivacy"
      width="69%"
      :before-close="handleClose">
      <h1 class="postTitle">Privacy Policy</h1>
      <div class="wpb_text_column wpb_content_element ">
        <div class="wpb_wrapper">
          Informazioni per il trattamento dei dati personali raccolti presso l’interessato (art. 13 Reg. UE 2016/679 – GDPR)
          In osservanza al Regolamento Generale sulla protezione dei Dati (UE) 2016/679 forniamo le dovute informazioni in ordine al trattamento dei dati personali effettuati attraverso il presente sito. L'informativa non è valida per altri siti web eventualmente consultabili tramite links presenti sul sito internet a dominio del titolare, che non è da considerarsi in alcun modo responsabile dei siti internet dei terzi.
          Si tratta di un'informativa che è resa ai sensi dell’art.13 del Regolamento Generale sulla protezione dei dati (UE) 2016/679 – GDPR. L'informativa si ispira anche alla Raccomandazione n. 2/2001 che le autorità europee per la protezione dei dati personali, riunite nel Gruppo istituito dall’art. 29 della direttiva n. 95/46/CE, hanno adottato il 17 maggio 2001 per individuare alcuni requisiti minimi per la raccolta di dati personali on-line e, in particolare, le modalità, i tempi e la natura delle informazioni che i titolari del trattamento devono fornire agli utenti quando questi si collegano a pagine web, indipendentemente dagli scopi del collegamento, nonché a quanto previsto dalla Direttiva 2002/58/CE, come aggiornata dalla Direttiva 2009/136/CE, in materia di Cookie e dal provvedimento dell'Autorità Garante "Individuazione delle modalità semplificate per l'informativa e l'acquisizione del consenso per l'uso dei cookie - 8 maggio 2014 (Pubblicato sulla Gazzetta Ufficiale n. 126 del 3 giugno 2014)" e successivi chiarimenti.
          Dato personale (art. 4 GDPR) «dato personale»: qualsiasi informazione riguardante una persona fisica identificata o identificabile («interessato»); si considera identificabile la persona fisica che può essere identificata, direttamente o indirettamente, con particolare riferimento a un identificativo come il nome, un numero di identificazione, dati relativi all’ubicazione, un identificativo online o a uno o più elementi caratteristici della sua identità fisica, fisiologica, genetica, psichica, economica, culturale o sociale; (C26, C30)
          Informative specifiche
          Informative specifiche potrebbero essere presentate nelle pagine del Sito in relazione a particolari servizi o trattamenti dei Dati forniti.
          Cookies
          Per maggiori informazioni sui cookies utilizzati dal presente sito web si veda la cookie policy al seguente <a href="../../static/documents/CookiePolicy.pdf" style="color: black; font-weight: bold">link</a>.
          <h4>1. IL "TITOLARE" DEL TRATTAMENTO</h4>
          Ai sensi degli artt. 4 e 24 del GDPR, il titolare del trattamento è Tenuta Ballerio Società Agricola srl, con sede in Località Case Nuove 9 - 27047 Case Nuove (PV) nella persona del legale rappresentante pro-tempore. L’email di contatto del titolare è info@tenutaballerio.com
          <h4>2. FINALITÀ E BASE GIURIDICA DEL TRATTAMENTO</h4>
          I dati personali saranno trattati nel rispetto delle condizioni di liceità ex art. 6 Reg. UE 2016/679 per le seguenti finalità:
          A) servizi di Tenuta Ballerio Società Agricola Srl:
          - navigazione sul presente sito internet,
          - richiesta di contatto, customer care e per richieste di informazioni sui servizi di Tenuta Ballerio Società Agricola Srl
          - raccolta dati e compilazioni di form online per aderire a servizi del Titolare;
          - acquisti on-line e attività amministrativo-contabili connesse. Ai fini dell'applicazione delle disposizioni in materia di protezione dei dati personali, i trattamenti effettuati per finalità amministrativo-contabili sono quelli connessi allo svolgimento delle attività di natura organizzativa, amministrativa, finanziaria e contabile, a prescindere dalla natura dei dati trattati. In particolare, perseguono tali finalità le attività organizzative interne, quelle funzionali all'adempimento di obblighi contrattuali e precontrattuali, attività informativa, spedizioni ed eventuali resi;
          B) per attività di marketing diretto, newsletters e promozioni, ricerche di mercato o altre ricerche campionarie e vendita diretta, rilevazione del grado di soddisfazione, tramite mezzi automatizzati posta elettronica, messaggi MMS o SMS, social networks e applicazioni, nonchè mediante telefonate tramite operatore e posta cartacea, aventi ad oggetto invio di materiale informativo, promozionale, commerciale e pubblicitario inerente ad eventi ed iniziative su prodotti, servizi, offerte, promozioni, da parte di Tenuta Ballerio Società Agricola Srl, anche attraverso le società di gestione (managing company) nominate responsabili del trattamento. I dati saranno inseriti nel CRM aziendale.
          C) per attività informative e promozionali verso propri Clienti. L’utilizzo delle coordinate di posta elettronica fornite dal cliente nel contesto della vendita di un prodotto o di un servizio a fini di vendita diretta di propri prodotti o servizi, è consentito ai fini di invio di informative e newsletter. L'interessato, al momento della raccolta e in occasione dell'invio di ogni comunicazione, è informato della possibilità di opporsi in ogni momento al trattamento, in maniera agevole e gratuitamente (art. 130 comma 4 del D.Lgs. 196/03). Per cancellarsi dalla mailing list sarà sufficiente scrivere in qualsiasi momento una e-mail all’indirizzo e-mail info@tenutaballerio.com ovvero per posta all’indirizzo fisico del titolare sopra indicato (sede) con oggetto “cancellazione mailing list”.
          Il trattamento dati ai sensi della finalità A) si basa sull’esecuzione di un contratto di cui l’interessato è parte o sull’esecuzione di misure precontrattuali adottate su richiesta dell’interessato.
          Il trattamento dati ai sensi della finalità B) si basa sul consenso ex. articolo 6, paragrafo 1, lettera a) GDPR.
          Il trattamento dati ai sensi della finalità C) si basa sul legittimo interesse del Titolare ex. articolo 6, paragrafo 1, lettera f) GDPR.
          <h4>4. DESTINATARI O CATEGORIE DI DESTINATARI DEI DATI</h4>
          I dati di natura personale forniti saranno comunicati a destinatari, che tratteranno i dati in qualità di responsabili (art. 28 del Reg. UE 2016/679) o di autonomi titolari. Più precisamente, i dati saranno comunicati a: società contrattualmente legate a Tenuta Ballerio Società Agricola Srl, a società collegate e/o controllate all'interno dell'Unione Europea e in paesi extra UE, in conformità della normativa vigente, anche attraverso le società di gestione (managing company). I dati potranno essere comunicati a terzi appartenenti alle seguenti categorie:
          - alla rete di vendita/distributiva su territorio;
          - soggetti che forniscono servizi per la gestione del sistema informativo usato da Tenuta Ballerio Società Agricola Srl e delle reti di telecomunicazioni (ivi compresa la posta elettronica, gestione Data Base CRM e mailing list, piattaforme e-commerce, fornitori APP, ecc…);
          - soggetti terzi per supporto ad acquisti on-line e attività amministrativo-contabili connesse, spedizioni ed eventuali resi (es. banche, assicurazioni, spedizionieri);
          - studi o società nell'ambito di rapporti di assistenza e consulenza;
          - autorità competenti per adempimenti di obblighi di leggi e/o di disposizioni di organi pubblici, su richiesta. I soggetti appartenenti alle categorie suddette svolgono la funzione di Responsabile del trattamento dei dati, oppure operano in totale autonomia come distinti Titolari del trattamento. L'elenco dei responsabili è costantemente aggiornato e disponibile presso la sede di Tenuta Ballerio Società Agricola Srl .
          I dati saranno inoltre comunicati alle persone fisiche autorizzate che agiscono sotto l’autorità del Titolare e del Responsabile (art. 29 del Reg. UE 2016/679), per le finalità sopra elencate.
          <h4>5. TRASFERIMENTO DEI DATI VERSO UN PAESE TERZO E/O UN’ORGANIZZAZIONE INTERNAZIONALE E GARANZIE</h4>
          Per gestire le proprie attività di commercio elettronico, Tenuta Ballerio Società Agricola Srl potrà avvalersi di piattaforme cloud fornite da operatori terzi in qualità di responsabili del trattamento. A tale riguardo, La informiamo che i Suoi dati personali saranno conservati presso server situati in Italia.
          <h4>6. PERIODO DI CONSERVAZIONE DEI DATI O CRITERI PER DETERMINARE IL PERIODO</h4>
          Il trattamento sarà svolto in forma automatizzata e manuale, con modalità e strumenti volti a garantire la massima sicurezza e riservatezza, ad opera di soggetti di ciò appositamente autorizzati e incaricati. Nel rispetto di quanto previsto dall’art. 5 comma 1 lett. e) del Reg. UE 2016/679, i dati personali raccolti verranno conservati in una forma che consenta l’identificazione degli interessati per un arco di tempo non superiore al conseguimento delle finalità per le quali i dati personali sono trattati. La conservazione dei dati di natura personale forniti dipende dalla finalità del trattamento:
          - navigazione sul presente sito web (si veda la cookies policy al seguente <a href="../../static/documents/CookiePolicy.pdf" style="color: black; font-weight: bold">link</a> );
          - per richiesta di contatto (massimo 1 anno);
          - ricezione newsletter o comunicazioni promozionali in genere via e-mail (massimo 24 mesi);
          - vendite online (10 anni)
          Per avere maggiori informazioni in merito ai criteri di data retention, l’interessato può rivolgersi via mail al titolare del trattamento, all’indirizzo info@tenutaballerio.com
          <h4>7. DIRITTI DEGLI INTERESSATI</h4>
          L’interessato può far valere i suoi diritti come espressi dal Regolamento UE 2016/679, rivolgendosi al Titolare via e-mail all’indirizzo info@tenutaballerio.com o scrivendo alla sede del Titolare sopra indicata.
          L’interessato ha il diritto, in qualunque momento, di chiedere al Titolare del trattamento l’accesso ai Suoi dati personali (art. 15), la rettifica (art. 16) o la cancellazione (art 17) degli stessi, o la limitazione del trattamento (art 18) o di opporsi al loro trattamento per attività di marketing (art. 21). Infine, l’interessato ha il diritto alla portabilità del dato (art. 20).
          Revoca del consenso. Qualora il trattamento sia basato sul consenso, l’interessato ha il diritto di revocare il consenso in qualsiasi momento senza pregiudicare la liceità del trattamento basata sul consenso prestato prima della revoca.
          Per opporsi al trattamento e per esercitare gli altri diritti, l’interessato potrà scrivere a info@tenutaballerio.com.
          Non viene effettuato un processo decisionale automatizzato (art. 22).
          Ai sensi della Normativa Applicabile, l’interessato ha in ogni caso il diritto di proporre reclamo all’autorità di controllo competente (Garante per la Protezione dei Dati Personali) qualora ritenesse che il trattamento dei suoi Dati Personali sia contrario alla normativa vigente.
          <h4>8. NATURA DEL CONFERIMENTO E RIFIUTO</h4>
          Il conferimento dei dati per le finalità di cui al punto A) è facoltativo ma necessario. L'eventuale rifiuto del conferimento dei dati necessari rispetto al punto A) comporta l'impossibilità di usufruire dei servizi del Titolare del trattamento. Il conferimento e il consenso al trattamento per le finalità di cui al punto B) è facoltativo. L'eventuale rifiuto del consenso per la finalità illustrata nel punto B) sopra riportato, non comporta alcuna conseguenza negativa riguardo le finalità di cui al punto A). L’attività di marketing è solo eventuali e sarà realizzata solamente con il consenso specifico dell’interessato.
          <h4>9. MODIFICHE ALL'INFORMATIVA SULLA PRIVACY</h4>
          Il Titolare si riserva il diritto di modificare, aggiornare, aggiungere o rimuovere parti della presente informativa sulla privacy a propria discrezione e in qualsiasi momento. La persona interessata è tenuta a verificare periodicamente le eventuali modifiche. Al fine di facilitare tale verifica, l'informativa conterrà l'indicazione della data di aggiornamento.
          Data di aggiornamento: novembre 2018
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="setPrivacy('')">Rifiuta</el-button>
    <el-button type="primary" @click="setPrivacy(true)">Accetta</el-button>
  </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogCondVendita"
      width="69%"
      :before-close="handleClose">
      <h1 class="postTitle">Condizioni di Vendita</h1>
      <div class="wpb_text_column wpb_content_element ">
        <div class="wpb_wrapper">
          Le seguenti Condizioni Generali di Vendita disciplinano l’offerta e la vendita, insieme alle <a href="../../static/documents/CondizionidUso.pdf">Condizioni d’Uso</a> e all’<a href="../../static/documents/PrivacyPolicy.pdf">Informativa sulla privacy</a>, dei prodotti a marchio “Tenuta Ballerio” sul sito https://www.tenutaballerio.com (di seguito il Sito).
          Le presenti Condizioni Generali di Vendita sono redatte in conformità alle previsioni legislative di cui al Codice Civile Italiano, al D.lgs. n. 70/2014 in materia di servizi della società dell’informazione e di commercio elettronico, al Codice del Consumo, che disciplinano l’offerta e la vendita di prodotti tramite il sito www.tenutaballerio.com.
          I prodotti commercializzati su www.tenutaballerio.com sono venduti direttamente da TENUTA BALLERIO (il Venditore) con sede legale in Località Case Nuove, 9 - Santa Maria della Versa (PV) - Italia - C.F. e P.IVA 02542850181.
          <h4>AMBITO DI APPLICAZIONE</h4>
          Le Condizioni Generali di Vendita si applicano e disciplinano tutti i contratti di vendita conclusi attraverso il Sito del Venditore, come sopra identificato.
          Le Condizioni Generali di Vendita possono subire delle modifiche e ciascun Utente è tenuto a consultarle prima di procedere ad ogni acquisto. È onere dell’Utente verificare le Condizioni Generali di Vendita prima di inoltrare l’ordine.
          Il Venditore non è mai responsabile della fornitura di prodotti a marchio “Tenuta Ballerio” da parte di soggetti terzi presenti nel Sito attraverso links, banner o collegamenti ipertestuali. Prima di confermare ordini di terzi, l’Utente è tenuto a verificarne le Condizioni di Vendita.
          Le condizioni Generali di Vendita si applicano a prescindere dalla nazionalità dell’Utente, a condizione che la consegna dei prodotti debba avvenire in uno dei paesi per i quali il Sito prevede il servizio di vendita on-line.
          L’acquisto di prodotti sul Sito è riservato in via esclusiva a persone fisiche che agiscono in qualità di consumatori e che siano maggiori di anni 18.
          Per consumatore si intende ogni persona fisica che agisce per scopi estranei all’attività commerciale, imprenditoriale, artigianale e professionale eventualmente svolta.
          <h4>CONCLUSIONE DEL CONTRATTO</h4>
          Le presenti Condizioni Generali di Vendita sono parte integrante ed essenziale del contratto di vendita tra il Venditore e l’Utente.
          L’invio telematico dell’ordine da parte dell’Utente implica totale conoscenza e integrale accettazione delle presenti Condizioni Generali di Vendita, d’Uso e dell’Informativa sulla Privacy. Qualora l’Utente non sia d’accordo con uno o più termini contenuti nelle presenti Condizioni Generali di Vendita è pregato di astenersi dall’effettuare acquisti nel Sito.
          Per procedere all’acquisto online di uno o più prodotti, l’Utente dovrà fornire al Venditore, in ottemperanza alle disposizioni in materia di protezione dei dati personali, tutti i dati necessari per consentire a quest’ultimo di dare esecuzione agli ordini inoltrati.
          Per perfezionare l’acquisto, l’Utente è tenuto a confermare il pagamento del prezzo dei prodotti inseriti nel carrello. Gli ordini che non registrano la corrispondente transazione vengono annullati automaticamente.
          Quando l’Utente effettua un ordine riceverà una e-mail che contiene la conferma del ricevimento dell’ordine ed il riepilogo del medesimo: questa comunicazione non costituirà comunque accettazione automatica dell’ordine.
          Il Venditore si riserva il diritto di rifiutare gli ordini che risultino incompleti e non corretti o di utenti con i quali sia in corso una controversia relativa il pagamento di un ordine precedente. In tali eventualità l’Utente riceverà a mezzo e-mail il rifiuto dell’ordine specificamente motivato.
          Qualora i prodotti presentati sul Sito non siano più disponibili al momento dell’ultimo accesso al Sito ovvero dall’invio dell’ordine, sarà cura del Venditore comunicare all’Utente, entro 5 giorni a decorrere dal giorno successivo a quello in cui è trasmesso l’ordine, l’indisponibilità del prodotto ordinato. In caso di avvenuto pagamento il Venditore provvederà a rimborsare il prezzo senza essere tenuto ad ulteriori risarcimenti.
          Nel modulo d’ordine è contenuto un rinvio alle presenti Condizioni Generali di Vendita e all’Informativa sulla Privacy, nonché un riepilogo delle caratteristiche essenziali di ciascun prodotto ordinato ed il relativo prezzo, dei mezzi di pagamento accettati e delle modalità di consegna dei prodotti acquistati, dei costi di spedizione, delle condizioni per l’esercizio del diritto di recesso e delle modalità e dei tempi di restituzione dei prodotti acquistati.
          L’Utente può, in ogni momento, ottenere informazioni in merito allo stato di avanzamento del proprio ordine inviando una email a info@tenutaballerio.com .
          Le lingue del contratto sono italiano e Inglese.
          <h4>CARATTERISTICHE DEI PRODOTTI</h4>
          I prodotti posti in vendita attraverso il Sito sono prodotti vitivinicoli originali a marchio Tenuta Ballerio e attività proposte da Tenuta Ballerio (visite, corsi, eventi, ecc.) presenti nel catalogo online al momento dell’ordine.
          Il catalogo dei prodotti può essere aggiornato e modificato periodicamente, pertanto non viene garantita la permanenza di un prodotto tra quelli disponibili online.
          Ciascun prodotto è presentato da una scheda descrittiva dove vengono riportate tutte le caratteristiche essenziali; le immagini ed i colori dei prodotti offerti in vendita potrebbero non essere esattamente corrispondenti a quelli reali per effetto delle impostazioni dei sistemi informatici utilizzati dall’Utente per la visualizzazione del Sito. Le immagini dei prodotti devono, pertanto, intendersi indicative e fanno salve le normali tolleranze d’uso.
          <h4>PREZZI DI VENDITA</h4>
          Tutti i prezzi di vendita dei prodotti indicati all’interno del Sito sono comprensivi di IVA, se applicabile in ragione del paese di spedizione dei prodotti e di ogni altra imposta eventualmente applicabile alla vendita.
          I prezzi dei prodotti potrebbero essere soggetti ad aggiornamenti e variazioni. L’Utente è tenuto ad accertare il prezzo finale di vendita prima di inoltrare il relativo ordine. Il palese errore materiale riportato nel prezzo presente nel Sito rispetto al prezzo comunemente noto del prodotto prescelto comporta la facoltà del Venditore di non confermare la spedizione e procedere con il rimborso immediato del valore dell’acquisto versato dall’Utente senza che questi possa opporre eccezioni in merito.
          <h4>MODALITÀ DI PAGAMENTO</h4>
          Per il pagamento del prezzo dei prodotti e delle relative spese di spedizione e consegna, se previste, l’Utente potrà seguire una delle modalità indicate nel modulo d’ordine.
          In caso di pagamento mediante carta di credito, la procedura di pagamento si svolgerà tramite connessione protetta collegata direttamente all’istituto bancario titolare del servizio di pagamento online a cui i terzi non possono avervi accesso. In particolare le informazioni finanziarie (es. numero della carta di credito/ debito, data di scadenza) saranno inoltrate tramite protocollo crittografato, che forniscono i relativi servizi di pagamento elettronico a distanza, senza che terzi possano aversi accesso. Tali informazioni non saranno mai utilizzate e/o archiviate in alcun formato (incluso quello elettronico) dal Venditore.
          L’importo dell’ordine sarà addebitato il giorno dell’acquisto, salvo il diritto dell’Utente di vedersi riaccreditato l’importo in caso di inadempimento da parte del Venditore o mancata esecuzione del contratto per qualsiasi ragione.
          L’Utente è l’unico responsabile dei dati immessi pertanto garantisce di utilizzare solo carte di credito/ debito di cui ha la legittima disponibilità.
          <h4>MODALITÀ DI CONSEGNA</h4>
          I prodotti vengono consegnati, tramite corrieri convenzionati, direttamente all’Utente all’indirizzo di spedizione specificato nell’ordine.
          Compilando la scheda anagrafica necessaria ad attivare l’iter per l’esecuzione del presente contratto e le ulteriori comunicazioni, l’Utente autorizza il Venditore a comunicare i dati anagrafici ai corrieri e/o spedizionieri di fiducia utilizzati per la consegna dei prodotti acquistati in modo da permettere le procedure necessarie al loro recapito.
          Il Venditore farà il possibile per evadere l’ordine trasmesso entro 5 giorni lavorativi e comunque non oltre 30 giorni a decorrere dal giorno successivo a quello in cui l’Utente ha trasmesso l’ordine. I tempi di consegna comprendono solo giorni lavorativi e non prevedono le festività.
          Il Sito consente di richiedere la consegna dei prodotti ordinati ad un indirizzo diverso da quello proprio dell’Utente a condizione che sia compreso nel paese di residenza dell’Utente indicato sul sito; in ogni caso è onere dell’Utente indicare tutti i riferimenti necessari al buon esito della consegna.
          Non è mai possibile ritirare i prodotti acquistati attraverso il Sito direttamente presso il magazzino del Venditore.
          Le spese e le tipologie di spedizione previste possono variare a seconda del Paese e delle modalità di spedizione scelte dall’Utente. Dette spese ed ogni eventuale costo aggiuntivo sono a carico dell’Utente. Il relativo importo sarà espressamente e separatamente indicato nel riepilogo dell’ordine, prima che l’Utente proceda alla trasmissione dello stesso, nonché nell’e-mail di conferma dell’ordine.
          Sia in Italia che all’estero la procedura di consegna prevede che, in caso di assenza del destinatario al momento dell’accesso del corriere, l’incaricato lascerà un avviso, al fine di perfezionare successivamente la spedizione, nel quale verranno indicati i recapiti da contattare per concordare la seconda consegna. In caso di mancato accordo per la seconda consegna il pacco rimarrà in giacenza presso il magazzino del corriere e sarà onere dell’Utente provvedere al ritiro. Nel caso di mancato ritiro entro 4 giorni il pacco verrà restituito al Venditore. In tal caso il contratto dovrà intendersi risolto ai sensi dell’art. 1456 c.c., con comunicazione del Venditore inviata a mezzo e-mail all’Utente e dunque l’ordine sarà annullato.
          L’Utente ha sempre la possibilità di verificare lo stato del proprio ordine contattando il Venditore via email o via telefono ai recapiti di seguito riportati: info@tenutaballerio.com/tel. 347.6014109
          L’ordine deve essere fatto direttamente dal sito del Paese in cui verrà consegnato. Gli ordini effettuati dal Sito di un Paese diverso da quello di destinazione, o verso un indirizzo non accettato dal corriere verranno automaticamente cancellati.
          <h4>OBBLIGHI DELL’UTENTE</h4>
          È fatto severo divieto a persone minorenni di concludere un ordine nel Sito. I dati inseriti in fase di acquisto devono essere esclusivamente i propri reali dati personali e non di terze persone, oppure di fantasia. Il Venditore si riserva di perseguire legalmente ogni violazione ed abuso, nell’interesse e per la tutela dei consumatori tutti.
          L’Utente manleva il Venditore da ogni responsabilità derivante dall’emissione di documenti fiscali errati a causa di errori relativi ai dati forniti dall’Utente, essendone egli stesso unico responsabile del corretto inserimento. All’atto di ricevimento dei prodotti, l’Utente è tenuto a verificare la conformità degli stessi in relazione all’ordine. In particolare dovrà prestare attenzione alla corrispondenza tra numero di colli indicato sulla lettera del vettore e quelli consegnati e all’integrità della confezione. Eventuali anomalie (es. manomissioni, danneggiamento) dovranno essere specificate per iscritto direttamente nel documento di trasporto del corriere e l’Utente dovrà rifiutare la consegna. Contestualmente, l’Utente è tenuto a segnalare il fatto al Servizio Clienti del Venditore contattando il Venditore via email all’indirizzo info@tenutaballerio.com oppure telefonando al numero 347.6014109. Qualora l’Utente accettasse la consegna di prodotti manomessi, danneggiati, decadrà dalla garanzia legale di conformità dei prodotti.
          <h4>RESPONSABILITÀ</h4>
          Il Venditore non assume alcuna responsabilità per i disservizi imputabili a causa di forza maggiore quali, a titolo esemplificativo, incidenti, esplosioni, incendi, scioperi, terremoti e altri eventi che impediscono in tutto o in parte, di dare esecuzione al contratto nei tempi concordati.
          Il Venditore non sarà responsabile nei confronti di alcuna parte o di terzi in merito a danni, perdite e costi subiti a seguito della mancata esecuzione del contratto per le cause sopra citate, avendo il cliente diritto soltanto alla restituzione del prezzo corrisposto.
          Parimenti, il Venditore non è responsabile dell’eventuale uso fraudolento ed illecito che possa essere fatto da parte di terzi, di carte di credito, assegni ed altri mezzi di pagamento, all’atto del pagamento dei prodotti. Il Venditore infatti, in nessun momento della procedura d’acquisto è in grado di conoscere il numero di carta di credito dell’Utente il quale, aprendosi una connessione protetta, viene trasmesso direttamente al gestore del servizio di pagamento.
          <h4>DIRITTO DI RECESSO</h4>
          L’Utente può esercitare il diritto di recesso e restituire il prodotto ricevuto, senza alcuna penalità e senza specificarne il motivo, nel rispetto dei termini e delle modalità di seguito riportate e meglio dettagliate nella sezione <a href="../../static/documents/DirittodiRecessoeRegoleperlaRestituzione.pdf" style="color: black; font-weight: bold">Diritto di recesso e regole per la restituzione</a>.
          L’Utente può sempre effettuare la richiesta di reso, inviando una mail a info@tenutaballerio.com e seguendo la procedura indicata.
          I prodotti dovranno essere restituiti integri, non danneggiati e provvisti del codice a barre e di ogni eventuale altro sigillo che faccia parte dei prodotti; i prodotti che vengano restituiti incompleti, rovinati, danneggiati, deteriorati non saranno rimborsati.
          I prodotti che si intende rendere devono essere consegnati allo spedizioniere entro 14 giorni decorrenti dalla comunicazione dell’Utente al Venditore della propria volontà di recedere dal contratto.
          Le spese di restituzione dei prodotti saranno a carico del cliente finale. Dopo la restituzione dei prodotti, il Venditore provvederà ai necessari accertamenti relativi alla conformità degli stessi alle condizioni e ai termini ivi indicati.
          Qualora il diritto di recesso venga correttamente esercitato, il Venditore provvederà al rimborso delle eventuali somme già incassate dall’Utente per l’acquisto dei prodotti.
          Qualunque sia la modalità di pagamento utilizzata dall’Utente, il rimborso è attivato dal Venditore nel minor tempo possibile e comunque entro 14 giorni dalla data in cui il Venditore è venuto a conoscenza dell’esercizio del diritto di recesso, previa verifica della corretta esecuzione del medesimo e verifica dei prodotti restituiti.
          Il Venditore esegue il rimborso utilizzando lo stesso mezzo di pagamento adoperato dall’Utente per l’acquisto dei prodotti restituiti. Il Venditore non potrà in alcun modo effettuare un rimborso su carta di credito diversa da quella utilizzata per l’acquisto, ad eccezione del caso in cui la carta stessa sia scaduta nel frattempo o sia stata rubata: in tal caso l’Utente potrà inviare un’e-mail a info@tenutaballerio.com per concordare il mezzo di rimborso più appropriato.
          <h4>GARANZIA DI CONFORMITÀ</h4>
          Ai sensi di legge il Venditore ha l’obbligo di consegnare all’Utente beni conformi al contratto di vendita ed il Venditore risponde per eventuali difetti di conformità dei prodotti esistenti al momento consegna o che si manifestino entro due anni dalla consegna.
          Ai fini della validità della garanzia che precede, l’Utente deve denunciare al Venditore il difetto di conformità entro due mesi dalla scoperta, a pena di decadenza, contattando il Servizio Clienti tramite email all’indirizzo info@tenutaballerio.com. La denuncia dovrà contenere la descrizione accurata e completa dei vizi e difetti contestati.
          Il Servizio Clienti provvederà a comunicare all’Utente le istruzioni per la restituzione del prodotto difettoso che avverrà a spese del Venditore.
          L’Utente avrà diritto di chiedere la risoluzione del contratto e la restituzione di quanto pagato o, in via alternativa, la sostituzione del prodotto. In caso di vizio/ difetto lieve l’Utente avrà solo diritto alla sostituzione del prodotto.
          In ogni caso sono esclusi dalla garanzia legale i difetti di conformità derivanti da danneggiamenti dovuti a fatti accidentali o da responsabilità dell’Utente per uso non conforme alla destinazione d’uso del prodotto.
          <h4>LEGGE APPLICABILE</h4>
          Ogni controversia relativa all’applicazione, esecuzione, interpretazione e violazione dei contratti di vendita stipulati tramite il Sito è sottoposta alla legge italiana. In ogni caso, saranno fatti salvi i diritti eventualmente attribuiti al Consumatore da disposizioni inderogabili di legge vigenti nello Stato di residenza o domicilio di quest’ultimo.
          <h4>MODIFICHE E AGGIORNAMENTI</h4>
          Il Venditore si riserva il diritto di modificare il Sito, le politiche e le presenti Condizioni Generali di Vendita in qualsiasi momento per offrire nuovi prodotti o servizi, ovvero conformarsi a disposizioni di legge o regolamentari. L’Utente che accede al Sito e inoltra un ordine aderirà alle politiche e ai termini delle Condizioni Generali di Vendita di volta in volta vigenti al momento in cui l’ordine sarà effettuato, salvo che eventuali modifiche non abbiano efficacia retroattiva in forza della legge applicabile. Qualora una delle ivi presenti previsioni fosse ritenuta invalida, nulla o inapplicabile, tale condizione non pregiudicherà comunque la validità e l’efficacia delle altre previsioni.
          <h4>SERVIZIO CLIENTI E COMUNICAZIONI</h4>
          L’Utente potrà richiedere qualsiasi informazione tramite il servizio assistenza ai seguenti recapiti:<br>
          email: info@tenutaballerio.com<br>
          telefono: 347 6014109<br>
          *******
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="setCondVendita('')">Rifiuta</el-button>
    <el-button type="primary" @click="setCondVendita(true)">Accetta</el-button>
  </span>
    </el-dialog>
    <Footer></Footer>
  </div>
</template>

<script>
  import Footer from './Footer'
  import ShopSlider from './ShopSlider'
  import RiepilogoCarrello from "./RiepilogoCarrello";
  import Paypal from "./Paypal";
  import Bus from './Bus'

  export default {
    name: "completaordine",
    components: {Paypal, RiepilogoCarrello, Footer, ShopSlider},
    data() {
      var checkMail = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('Inserire email'));
        }
        setTimeout(() => {
          if (!this.validateEmail(value)) {
            callback(new Error('Email non valida'));
          } else {
            callback();
          }
        }, 500);
      };
      var checkCodfisc = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('Inserire codice fiscale'));
        }
        setTimeout(() => {
          if (!this.validateCodFisc(value)) {
            callback(new Error('Codice fiscale non valido'));
          } else {
            callback();
          }
        }, 500);
      };
      return {
        pickerOptions1: {
          disabledDate(time) {
            return time.getTime() > (Date.now() - 568036800000) //18 anni in millisecondi
          }
        },
        pageHeight: window.innerHeight,
        mailto: 'mailto:info@tenutaballerio.com?subject=Different%20State%20Request&body=Write%20to%20us%20to%20agree%20on%20shipping%20management.%20Unfortunately%20we%20cannot%20handle%20shipping%20via%20online%20shops',
        options: [{
          value: 'Italia',
          label: 'Italia'
        }, {
          value: 'Svizzera',
          label: 'Svizzera'
        }, {
          value: 'Germania',
          label: 'Germania'
        }, {
          value: 'Francia',
          label: 'Francia'
        }, {
          value: 'Spagna',
          label: 'Spagna'
        }, {
          value: 'Austria',
          label: 'Austria'
        }, {
          value: 'Liechestein',
          label: 'Liechestein'
        }, {
          value: 'Pr. di Monaco',
          label: 'Pr. di Monaco'
        }, {
          value: 'Slovenia',
          label: 'Slovenia'
        }, {
          value: 'Benelux',
          label: 'Benelux'
        }, {
          value: 'Gran Bretagna',
          label: 'Gran Bretagna'
        }, {
          value: 'Danimarca',
          label: 'Danimarca'
        }, {
          value: 'Finlandia',
          label: 'Finlandia'
        }, {
          value: 'Grecia',
          label: 'Grecia'
        }, {
          value: 'Irlanda',
          label: 'Irlanda'
        }, {
          value: 'Norvegia',
          label: 'Norvegia'
        }, {
          value: 'Portogallo',
          label: 'Portogallo'
        }, {
          value: 'Svezia',
          label: 'Svezia'
        }, {
          value: 'Bulgaria',
          label: 'Bulgaria'
        }, {
          value: 'Polonia',
          label: 'Polonia'
        }, {
          value: 'Rep. Ceca',
          label: 'Rep. Ceca'
        }, {
          value: 'Romania',
          label: 'Romania'
        }, {
          value: 'Slovacchia',
          label: 'Slovacchia'
        }, {
          value: 'Turchia',
          label: 'Turchia'
        }, {
          value: 'Ungheria',
          label: 'Ungheria'
        }],
        value: '',
        ship: '',
        priceShip: 15,
        qntyProd: [],
        checkProductCategory: [],
        pay: false,
        dialogPrivacy: false,
        dialogCondVendita: false,
        fattura: false,
        step: 0,
        totale: 0,
        divWidth: 0,
        reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
        form: {
          indResidenza: '',
          cityResidenza: '',
          capResidenza: '',
          provResidenza: '',
          nationResidenza: '',
          indFattura: '',
          cityFattura: '',
          capFattura: '',
          provFattura: '',
          nationFattura: '',
          ragsoc: '',
          iva: '',
          metodoPagamento: '',
          email: '',
          name: '',
          surname: '',
          tel: '',
          birthday: '',
          privacy: '',
          marketing: '',
          fiscCode: '',
          condizionivendita: ''
        },
        cart: [],
        winesAvailability: [],
        codfiscValidate: {
          required: true,
          regex: /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i
        },
        rules: {
          name: [
            {required: true, message: 'Inserire il nome', trigger: 'blur'}
          ],
          surname: [
            {required: true, message: 'Inserire il cognome', trigger: 'blur'}
          ],
          email: [
            {required: true, message: 'Inserire email', trigger: 'blur'},
            {validator: checkMail, trigger: 'blur'}
          ],
          tel: [
            {required: true, message: 'Inserire il telefono', trigger: 'blur'}
          ],
          birthday: [
            {type: 'date', required: true, message: 'Inserire la data di nascita', trigger: 'change'}
          ],
          indResidenza: [
            {required: true, message: 'Inserire indirizzo', trigger: 'blur'}
          ],
          cityResidenza: [
            {required: true, message: 'Inserire la città', trigger: 'blur'}
          ],
          capResidenza: [
            {required: true, message: 'Inserire il CAP', trigger: 'blur'}
          ],
          provResidenza: [
            {required: true, message: 'Inserire la provincia', trigger: 'blur'}
          ],
          nationResidenza: [
            {required: true, message: 'Selezionare la nazione', trigger: 'change'}
          ],
          metodoPagamento: [
            {required: true, message: 'Selezionare il metodo di pagamento', trigger: 'change'}
          ],
          fiscCode: [
            {required: true, message: 'Inserire codice fiscale', trigger: 'blur'},
            {validator: checkCodfisc, trigger: 'blur'}
          ],
          privacy: [
            {required: true, message: 'Accettare il documento sulla privacy', trigger: 'change'}
          ],
          condizionivendita: [
            {required: true, message: 'Accettare il documento sulle condizioni di vendita', trigger: 'change'}
          ]
        }
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          summary: 'Prodotti',
          form: 'Dati Ordine'
        },
        en: {
          summary: 'Summary',
          form: 'Fill in the request'
        }
      }
    },
    watch: {
      form: {
        handler: function (val) {
          this.priceShip = this.shipping()
          this.$forceUpdate()
        },
        deep: true
      }
    },
    updated: function () {
      window.addEventListener('resize', this.getDivWidth)
    },
    mounted: function () {
      this.checkProductQnty()
      // Bus.$off('successPay') //per cancellare le vecchie istanze del Bus
      if (localStorage.getItem('idCarrello') === undefined || localStorage.getItem('idCarrello') === null) {
        this.$router.push({name: 'homepage'})
      }
      window.scroll(0, 0)
      this.listCart()
    },
    methods: {
      successPay: function () {
        this.setPrenotazione()
        this.step = 1
        this.$forceUpdate()
      },
      enablePay: function (form) {
        this.onSubmit(form)
      },
      setVisible: function () {
        if (this.fattura) {
          this.fattura = false
        } else {
          this.fattura = true
        }
      },
      validateEmail: function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      },
      validateCodFisc: function (codFisc) {
        var re = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i;
        return re.test(String(codFisc).toLowerCase());
      },
      checkSpecialChar: function (str, campo) {
        let res = str.replace(/([.*+?^=!:${}()<>&|\[\]\/\\])/g, '');
        switch (campo) {
          case 'name':
            this.form.name = res;
            break;
          case 'surname':
            this.form.surname = res;
            break;
          case 'ragsoc':
            this.form.ragsoc = res;
            break;
          case 'indResidenza':
            this.form.indResidenza = res;
            break;
          case 'cityResidenza':
            this.form.cityResidenza = res;
            break;
          case 'provResidenza':
            this.form.provResidenza = res;
            break;
          case 'indFattura':
            this.form.indFattura = res;
            break;
          case 'cityFattura':
            this.form.cityFattura = res;
            break;
          case 'provFattura':
            this.form.provFattura = res;
            break;
          case 'iva':
            this.form.iva = res;
            break;
        }
      },
      writeMail: function (dest) {
        location.href = dest
      },
      handleClose(done) {
        this.$confirm('Are you sure to close this dialog?')
          .then(_ => {
            done()
          })
          .catch(_ => {
          })
      },
      listCart: function () {
        this.$http.get('/ws-shop/cart/', {params: {idCarrello: localStorage.getItem('idCarrello')}}).then(response => {
          this.cart = response.body.data
          this.totale = response.body.totale

          this.cart.forEach(row => {
            if (row.category === 5) {
              this.checkProductCategory.push(true)
            } else this.checkProductCategory.push(false)
          })
          this.priceShip = this.shipping()
        })
      },
      // checkEmail: function (mail) {
      //   this.$http.get('/ws-shop/order/checkEmail', {params: {'email': mail}}).then(response => {
      //     if (response.body.data.email) {
      //       this.form = response.body.data
      //     }
      //   })
      // },
      checkProductQnty: function () {
        this.$http.get('/ws-shop/order/checkProductQnty', {params: {idCarrello: localStorage.getItem('idCarrello')}}).then(response => {
          if (response.body.rc === 0) {
            this.winesAvailability = response.body.data
            this.winesAvailability.forEach(row => {
              if (row.qnty === false) {
                // console.log('Quantità di ' + row.idProduct + ' non disponibile')
                // this.qntyProd[row.idProduct] = false
                this.qntyProd.push(false)
              } else this.qntyProd.push(true)
            })
          }
        })
      },
      /* $set rende reattivo un attributo annidato in un json del data */
      setPrivacy: function (value) {
        this.dialogPrivacy = false
        this.$set(this.form, 'privacy', value)
      },
      setCondVendita: function (value) {
        this.dialogCondVendita = false
        this.$set(this.form, 'condizionivendita', value)
      },
      onSubmit(formName) {
        this.checkProductQnty()
        this.$validator.validate().then(result => {
          if (result) {
            this.registrazione(formName)
          } else {
            // console.log('error submit!   !')
            this.pay = false
          }
        });
      },
      registrazione(formName) {
        if (this.$refs[formName]) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // console.log("nazione: " + this.form.nationResidenza)
              this.pay = true
            } else {
              // console.log('error submit!!')
              this.pay = false
            }
          })
        } else {
          // console.log('errore: propName = ' + formName)
        }
      },
      setPrenotazione: function () {
        // this.$gtag.event('completaOrdine', {value: 'submit'})
        if (this.form.marketing === true) this.form.marketing = 1
        else this.form.marketing = 0
        if (this.form.privacy === true) this.form.privacy = 1
        else this.form.privacy = 0
        if (this.form.condizionivendita === true) this.form.condizionivendita = 1
        else this.form.condizionivendita = 0
        let data = {
          'idCartEncrypted': localStorage.getItem('idCarrello'),
          'priceTot': this.totale,
          'qntyTot': this.cart.length,
          'indResidenza': this.form.indResidenza,
          'cityResidenza': this.form.cityResidenza,
          'capResidenza': this.form.capResidenza,
          'provResidenza': this.form.provResidenza,
          'nationResidenza': this.form.nationResidenza,
          'indFattura': this.form.indFattura,
          'cityFattura': this.form.cityFattura,
          'capFattura': this.form.capFattura,
          'provFattura': this.form.provFattura,
          'nationFattura': this.form.nationFattura,
          'ragSoc': this.form.ragsoc,
          'iva': this.form.iva,
          'metodoPagamento': 'Paypal',
          'email': this.form.email,
          'name': this.form.name,
          'surname': this.form.surname,
          'tel': this.form.tel,
          'birth': this.form.birthday,
          'privacy': parseInt(this.form.privacy),
          'marketing': parseInt(this.form.marketing),
          'fiscCode': this.form.fiscCode,
          'condizionivendita': parseInt(this.form.condizionivendita)
        }
        this.$http.post('/ws-shop/order/save', data).then(response => {
          if (response.body.rc === 0) {
            localStorage.removeItem('idCarrello')
            Bus.$emit('azzeraCart')
          }
        })
        this.step = 1
      },
      isEmailValid: function () {
        return (this.email == "") ? "" : (this.reg.test(this.form.email)) ? 'has-success' : 'has-error';
      },
      shipping: function () {
        return (this.totale >= 450 || !this.checkProductCategory.includes(false)) ? 0 : ((this.form.nationResidenza === '' || this.form.nationResidenza === 'Italia') ? 15 : 30);
      },
      authenticate: function (provider) {
        this.$auth.authenticate(provider).then(function () {
          // Execute application logic after successful social authentication
        })
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #completaordine {
    background-color: @darkGray;
    .el-select {
      width: 160px;
    }
    input {
      background-color: @lightBlack;
      border-color: #535455;
      color: white;
      letter-spacing: 1px;
    }
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: initial;
      margin: 0;
    }
    .directory {
      padding-left: 75px;
      padding-top: 30px;
      letter-spacing: 1px;
      .set-font(@size: 13px);
    }
    .categoria {
      width: 80%;
      margin: auto;
      text-align: center;
      padding: 20px;
      border-bottom: 1px solid white;
      .set-font-title();
    }
    .testoRiepilogo {
      width: 80%;
      margin: auto;
      margin-top: 25px;
      letter-spacing: 1px;
      padding-right: 0px;
      padding-left: 0px;
      .set-font();
      #nomeCamera {
        font-size: 20px;
        font-weight: bold;
      }
      .righeRiepilogo {
        border: .5px;
        border-style: solid;
        border-color: white;
        justify-content: space-between;
        border-bottom: 0.5px solid;
        background-color: @lightBlack;
        margin-bottom: 20px;
        #imgVino {
          width: 40%;
          border-style: solid;
          border-width: 0px 0.5px 0px 0px;
          text-align: center;
          .vinoimg {
            width: 112px;
            margin: auto;
            padding: 15px;
          }
          .notVinoimg {
            opacity: 0.4;
            width: 112px;
            margin: auto;
            padding: 15px;
          }
          .smartboximg {
            width: 160px;
            margin: auto;
            padding: 15px;
          }
          .notSmartboximg {
            opacity: 0.4;
            width: 160px;
            margin: auto;
            padding: 15px;
          }
        }
        .notAvailable {
          .set-font(@color: orange)
        }
      }
      .testoDestra {
        .set-font(@weight: bold);
      }
    }
    .somma {
      border: .5px;
      border-style: solid;
      border-color: grey;
      width: 80%;
      margin: auto;
      letter-spacing: 1px;
      background-color: white;
      margin-top: 25px;
      margin-bottom: 130px;
      .set-font(@color: black);
      .sumRiepilogo {
        width: 50%;
        margin: auto;
        display: block;
      }
    }
    .form {
      border: .5px;
      border-style: solid;
      border-color: white;
      text-align: center;
      width: 80%;
      margin: auto;
      margin-top: 25px;
      margin-bottom: 50px;
      background-color: @lightBlack;
      padding: 30px;
      letter-spacing: 1px;
      .set-font();
      .horeca {
        padding-bottom: 20px;
        text-align: center;
        padding-top: 10px;
        font-weight: bold;
        font-size: 16px;
      }
      .el-form-item__label {
        width: 30% !important;
        padding: 0 3px 0 0;
        .set-font(@size: 14px);
      }
      .notinlista {
        width: 45% !important;
      }
      .el-checkbox {
        display: inline-flex;
        width: 81%;
        .el-checkbox__label {
          white-space: pre-wrap !important;
          letter-spacing: 1px;
          width: 100%;
          text-align: left;
        }
      }
      .el-input {
        width: 80%;
        .el-input__inner {
          width: 100%;
        }
      }
      .el-textarea {
        width: 80%;
        .el-textarea__inner {
          width: 100%;
          background-color: @lightBlack;
          border-color: #535455;
          color: white;
        }
      }
    }
    .indietro {
      width: 230px;
      background-color: @lightBlack;
      border-color: white;
      margin-left: 7%;
      text-align: center;
      letter-spacing: 1px;
      height: 40px;
      margin-top: -123px;
      z-index: 100;
      .set-font()
    }
    .informazioni {
      width: 230px;
      margin: auto;
    }
    .categoria:after {
      border: 1px solid white;
    }
    .el-dialog__wrapper {
      .el-dialog {
        .el-dialog__body {
          height: 500px !important;
          overflow-y: scroll !important;
        }
      }
    }
  }

  @media (max-width: 768px) {
    #completaordine {
      .directory {
        .set-font(@size: 13px);
      }
      .categoria {
        .set-font-title();
      }
      .testoRiepilogo {
        .set-font(@size: 13px);
        #nomeCamera {
        }
        .righeRiepilogo {
          #imgVino {
            .vinoimg {
              width: 70%;
            }
            .notvinoimg {
              width: 70%;
            }
            .smartboximg {
              width: 90%;
            }
            .notSmartboximg {
              width: 90%;
            }
          }
        }
        .testoDestra {
          .set-font(@weight: bold);
        }
      }
      .somma {
        margin-bottom: 10px;
        .set-font(@size: 14px, @color: black);
        .sumRiepilogo {
          width: 100%;
        }
      }
      .form {
        padding: 10px;
        margin-bottom: 30px;
        .set-font(@size: 13px);
        .horeca {
          font-size: 13px;
        }
        .notinlista {
          width: 100%;
        }
        .el-checkbox {
          width: 100% !important;
          .el-checkbox__label {
          }
        }
        .el-form-item__label {
          float: inherit;
          width: 100% !important;
          text-align: left;
          .set-font(@size: 11px);
        }
        .el-form-item__content {
          margin-left: 0px !important;
          font-size: 8px;
          text-align: left;
          .el-button {
            .el-checkbox {
              white-space: pre-wrap;
              .el-checkbox_input {
                .el-checkbox_label {
                  white-space: pre-wrap;
                }
              }
            }
          }
        }
        .el-input {
          width: 100%;
          .el-input__inner {
          }
        }
        .el-textarea {
          width: 100%;
          .el-textarea__inner {
          }
        }
      }
      .indietro {
        width: 130px;
        height: 35px;
        margin-top: 0px;
        .set-font(@size: 13px)
      }
      .informazioni {
        width: 130px;
        height: 35px;
        .set-font(@size: 13px)
      }
      .categoria:after {
      }
      .el-dialog__wrapper {
        .el-dialog {
          width: 90% !important;
          .el-dialog__body {
            height: 300px !important;
            overflow-y: scroll !important;
          }
          .el-dialog__footer {
            .el-button {
              margin-left: 10px;
            }
          }
        }
      }
      .el-radio + .el-radio {
        margin-left: 0px;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    #completaordine {
      .directory {
        .set-font(@size: 13px);
      }
      .categoria {
        .set-font-title();
      }
      .testoRiepilogo {
        .set-font();
        #nomeCamera {
        }
        .righeRiepilogo {
          #imgVino {
            .vinoimg {
              width: 15%;
            }
            .smartboximg {
              width: 35%;
            }
            .notSmartboximg {
              width: 35%;
            }
          }
        }
        .testoDestra {
          .set-font(@weight: bold);
        }
      }
      .somma {
        .set-font(@color: black);
        .sumRiepilogo {
        }
      }
      .form {
        .set-font();
        .el-form-item__label {
          .set-font(@size: 14px);
        }
        .el-checkbox {
          .el-checkbox__label {
          }
        }
        .el-input {
          .el-input__inner {
          }
        }
        .el-textarea {
          .el-textarea__inner {
          }
        }
      }
      .indietro {
        margin-top: 0px;
        .set-font()
      }
      .informazioni {
        .set-font()
      }
      .categoria:after {
      }
      .el-dialog__wrapper {
        .el-dialog {
          .el-dialog__body {
          }
        }
      }
    }
  }

  @media (min-width: 1025px) and (max-width: 1366px) {
    #completaordine {
      .directory {
        .set-font(@size: 13px);
      }
      .categoria {
        .set-font-title();
      }
      .testoRiepilogo {
        .set-font();
        #nomeCamera {
        }
        .righeRiepilogo {
          #imgVino {
            .vinoimg {
              width: 100%;
            }
          }
        }
        .testoDestra {
          .set-font(@weight: bold);
        }
      }
      .somma {
        .set-font(@color: black);
        .sumRiepilogo {
        }
      }
      .form {
        .set-font();
        .el-form-item__label {
          .set-font(@size: 14px);
        }
        .el-checkbox {
          .el-checkbox__label {
          }
        }
        .el-input {
          .el-input__inner {
          }
        }
        .el-textarea {
          .el-textarea__inner {
          }
        }
      }
      .indietro {
        .set-font()
      }
      .informazioni {
        .set-font()
      }
      .categoria:after {
      }
      .el-dialog__wrapper {
        .el-dialog {
          .el-dialog__body {
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CompletaOrdine.vue